export default function onRender(componentId, phase, actualDuration) {
    if (actualDuration) {
      // console.info(componentId, phase, actualDuration);
    }
  }
  